export var GarHouseType;
(function (GarHouseType) {
    GarHouseType["None"] = "None";
    GarHouseType["Hold"] = "Hold";
    GarHouseType["House"] = "House";
    GarHouseType["HouseHold"] = "HouseHold";
    GarHouseType["Garage"] = "Garage";
    GarHouseType["Building"] = "Building";
    GarHouseType["Mine"] = "Mine";
    GarHouseType["Structure"] = "Structure";
    GarHouseType["Construction"] = "Construction";
    GarHouseType["Litera"] = "Litera";
    GarHouseType["Housing"] = "Housing";
    GarHouseType["Basement"] = "Basement";
    GarHouseType["BoilerRoom"] = "BoilerRoom";
    GarHouseType["Cellar"] = "Cellar";
    GarHouseType["UnfinishedConstruction"] = "UnfinishedConstruction";
})(GarHouseType || (GarHouseType = {}));
export var GarHouseAddType;
(function (GarHouseAddType) {
    GarHouseAddType["None"] = "None";
    GarHouseAddType["Structure"] = "Structure";
    GarHouseAddType["Construction"] = "Construction";
    GarHouseAddType["Litera"] = "Litera";
    GarHouseAddType["Housing"] = "Housing";
})(GarHouseAddType || (GarHouseAddType = {}));
export var FiasDivision;
(function (FiasDivision) {
    FiasDivision["Administrative"] = "administrative";
    FiasDivision["Municipal"] = "municipal";
})(FiasDivision || (FiasDivision = {}));
export var FiasSchema;
(function (FiasSchema) {
    FiasSchema["Fias"] = "fias";
    FiasSchema["Gar"] = "gar";
})(FiasSchema || (FiasSchema = {}));
export var FiasSuggestLevels;
(function (FiasSuggestLevels) {
    FiasSuggestLevels["House"] = "House";
    FiasSuggestLevels["Room"] = "Room";
})(FiasSuggestLevels || (FiasSuggestLevels = {}));
export var FiasEstateStatuses;
(function (FiasEstateStatuses) {
    FiasEstateStatuses["None"] = "None";
    FiasEstateStatuses["Hold"] = "Hold";
    FiasEstateStatuses["House"] = "House";
    FiasEstateStatuses["HouseHold"] = "HouseHold";
    FiasEstateStatuses["Garage"] = "Garage";
    FiasEstateStatuses["Building"] = "Building";
    FiasEstateStatuses["Mine"] = "Mine";
    FiasEstateStatuses["Basement"] = "Basement";
    FiasEstateStatuses["BoilerRoom"] = "BoilerRoom";
    FiasEstateStatuses["Cellar"] = "Cellar";
})(FiasEstateStatuses || (FiasEstateStatuses = {}));
export var FiasStructureStatuses;
(function (FiasStructureStatuses) {
    FiasStructureStatuses["Structure"] = "Structure";
    FiasStructureStatuses["Construction"] = "Construction";
    FiasStructureStatuses["Liter"] = "Liter";
    FiasStructureStatuses["None"] = "None";
})(FiasStructureStatuses || (FiasStructureStatuses = {}));
export var FiasLiveStatuses;
(function (FiasLiveStatuses) {
    FiasLiveStatuses["active"] = "active";
    FiasLiveStatuses["inactive"] = "inactive";
})(FiasLiveStatuses || (FiasLiveStatuses = {}));
export var FiasFlatType;
(function (FiasFlatType) {
    FiasFlatType[FiasFlatType["None"] = 0] = "None";
    FiasFlatType[FiasFlatType["Placement"] = 1] = "Placement";
    FiasFlatType[FiasFlatType["Apartment"] = 2] = "Apartment";
    FiasFlatType[FiasFlatType["Office"] = 3] = "Office";
    FiasFlatType[FiasFlatType["Room"] = 4] = "Room";
    FiasFlatType[FiasFlatType["WorkArea"] = 5] = "WorkArea";
    FiasFlatType[FiasFlatType["Stock"] = 6] = "Stock";
    FiasFlatType[FiasFlatType["ShoppingRoom"] = 7] = "ShoppingRoom";
    FiasFlatType[FiasFlatType["Workshop"] = 8] = "Workshop";
    FiasFlatType[FiasFlatType["Pavilion"] = 9] = "Pavilion";
    FiasFlatType[FiasFlatType["Basement"] = 10] = "Basement";
    FiasFlatType[FiasFlatType["BoilerRoom"] = 11] = "BoilerRoom";
    FiasFlatType[FiasFlatType["Cellar"] = 12] = "Cellar";
    FiasFlatType[FiasFlatType["Garage"] = 13] = "Garage";
    FiasFlatType[FiasFlatType["CarPlace"] = 14] = "CarPlace";
})(FiasFlatType || (FiasFlatType = {}));
export var FiasRoomType;
(function (FiasRoomType) {
    FiasRoomType[FiasRoomType["None"] = 0] = "None";
    FiasRoomType[FiasRoomType["Room"] = 1] = "Room";
    FiasRoomType[FiasRoomType["Placement"] = 2] = "Placement";
})(FiasRoomType || (FiasRoomType = {}));
export var FiasFields;
(function (FiasFields) {
    FiasFields["region"] = "region";
    FiasFields["district"] = "district";
    FiasFields["municipaldistrict"] = "municipaldistrict";
    FiasFields["city"] = "city";
    FiasFields["intracityarea"] = "intracityarea";
    FiasFields["urbansettlement"] = "urbansettlement";
    FiasFields["settlement"] = "settlement";
    FiasFields["planningstructure"] = "planningstructure";
    FiasFields["street"] = "street";
    FiasFields["stead"] = "stead";
    FiasFields["house"] = "house";
    FiasFields["garhouse"] = "garhouse";
    FiasFields["room"] = "room";
    FiasFields["apartment"] = "apartment";
})(FiasFields || (FiasFields = {}));
export var FiasExtraFields;
(function (FiasExtraFields) {
    FiasExtraFields["postalcode"] = "postalcode";
})(FiasExtraFields || (FiasExtraFields = {}));
export var FiasFormValidation;
(function (FiasFormValidation) {
    FiasFormValidation["Error"] = "Error";
    FiasFormValidation["Warning"] = "Warning";
    FiasFormValidation["None"] = "None";
})(FiasFormValidation || (FiasFormValidation = {}));
